import axios from "axios";
import { format } from "date-fns";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dd_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Coś poszło nie tak. Spróbuj ponownie.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const zl = (n) => `${Math.round(Number(n) || 0)} zł`;
export const ymd = (d) => format(d, "yyyy-MM-dd");
export const plDate = (s) => (s ? s.split("-").reverse().join(".") : "");

export const CAR_TYPES = [
  { id: "sedan", label: "Sedan" },
  { id: "suv", label: "SUV" },
  { id: "kombi", label: "Kombi" },
  { id: "van", label: "Van" },
];
export const carLabel = (id) => CAR_TYPES.find((c) => c.id === id)?.label || id;
export const SERVICE_LABELS = { stationary: "Detailing stacjonarny", mobile: "Detailing mobilny" };
